import { Transform, Type } from 'class-transformer';
import { dateTransformer } from 'src/lib/utilities/api/class-transformer-types';
import {
	RoleManagerStudentPerformance,
	RoleManagerStudentPerformance_ClassTransform_Type,
} from '../assignment-manager/role-manager-student-load.model';
import {
	MeetupMinutesModel,
	MeetupMinutesModel_ClassTransform_Type,
} from '../organizations/meetups/meetup-minutes.model';
import {
	StudentGraduationPacingModel,
	StudentGraduationPacingModel_ClassTransform_Type,
} from '../students/student-graduation-pacing.model';
import {
	WorkQueueTrackerResponseModel,
	WorkQueueTrackerResponseModel_ClassTransform_Type,
} from '../work-queue/work-queue-entity.model';
import {
	TrackerClassModel,
	TrackerClassModel_ClassTransform_Type,
} from './tracker-class.model';
import {
	TrackerContactTypeModel,
	TrackerContactTypeModel_ClassTransform_Type,
} from './tracker-contact-type.model';
import {
	TrackerStudentPropertyModel,
	TrackerStudentPropertyModel_ClassTransform_Type,
} from './tracker-student-property.model';

export class LCTrackerGraduationModel {
	credits_remain: number;
	@Transform(dateTransformer)
	expected_date: Date;
	@Type(StudentGraduationPacingModel_ClassTransform_Type)
	pacing: StudentGraduationPacingModel;
}

export function LCTrackerGraduationModel_ClassTransform_Type() {
	return LCTrackerGraduationModel;
}

export class LCTrackerItemModel {
	uid: number;
	profile_first_name: string;
	profile_last_name: string;
	profile_preferred_name: string;

	assigned_uid: number;
	@Transform(dateTransformer)
	assigned_at: Date;
	assigned_first: string;
	assigned_last: string;
	assigned_fa_uid: number | null;
	assigned_fa_first: string | null;
	assigned_fa_last: string | null;
	user_link_id: number;
	mail: string;
	program_type: string;
	program: string;
	is_paused: boolean;
	grade: string;
	age: number;
	program_pacing: string;
	@Type(LCTrackerGraduationModel_ClassTransform_Type)
	graduation: LCTrackerGraduationModel;
	is_1418: number;
	iep_504: string;
	esl: string;
	@Type(TrackerContactTypeModel_ClassTransform_Type)
	last_contact: Partial<TrackerContactTypeModel>;
	@Type(TrackerContactTypeModel_ClassTransform_Type)
	last_attempt: Partial<TrackerContactTypeModel>;
	last_login: Date;
	@Transform(dateTransformer)
	activated: Date;
	days_since_last_submission: number;
	weekly_assignments: number;
	@Type(MeetupMinutesModel_ClassTransform_Type)
	meetup_minutes: MeetupMinutesModel;
	counted_classes: number;
	completed_class_count: number;
	@Type(TrackerClassModel_ClassTransform_Type)
	classes: TrackerClassModel[];
	persistent_courses: number;
	reenrolled: boolean;
	tags: string[];
	@Transform(dateTransformer)
	deactivated: Date;
	@Transform(dateTransformer)
	most_recent_enrolled: Date;
	@Transform(dateTransformer)
	star_math: Date;
	@Transform(dateTransformer)
	star_reading: Date;
	star_math_percentile: number;
	star_reading_percentile: number;

	literacy: number;
	numeracy: number;
	@Type(WorkQueueTrackerResponseModel_ClassTransform_Type)
	queues: WorkQueueTrackerResponseModel[];
	timezone: string;

	completed_classes: TrackerClassModel[];

	cohort_year: number;
	custom_district: string | null;
	district_residence: string | null;
	credits_remain: number;
	institute_id: number;

	@Transform(dateTransformer)
	access: Date;

	@Transform(dateTransformer)
	enrolled: Date;

	student_location: string;
	parent_title: string;
	state_program: string;
	//program title
	title: string;
	profile_student_year: string;
	phone: number;
	phone_type: string;

	@Transform(dateTransformer)
	safe_funding_expiration: Date;
	track: string;

	pending_files: number;
	credits: number;

	@Transform(dateTransformer)
	birthdate: Date;
	graduation_request_status_title: string;

	@Type(TrackerStudentPropertyModel_ClassTransform_Type)
	student_properties: TrackerStudentPropertyModel[];

	@Type(RoleManagerStudentPerformance_ClassTransform_Type)
	performance_data: RoleManagerStudentPerformance;
}

export function LCTrackerItemModel_ClassTransform_Type() {
	return LCTrackerItemModel;
}

export class LCTrackerModel {
	count: number;
	skip: number;
	take: number;
	@Type(LCTrackerItemModel_ClassTransform_Type)
	results: LCTrackerItemModel[];
}
